export default __webpack_public_path__ + "static/media/bn.12351131.svg";